import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginService } from '../core/login.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    retryCount = 0;

    constructor(private authenticationService: LoginService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            console.log("ERrr: ", err)
            if ([401, 403].includes(err.status) && this.authenticationService.userValue) {
                // auto logout if 401 or 403 response returned from api
                if(!this.retryCount) {
                    this.authenticationService.refreshToken().subscribe((data) => { 
                        return request.clone();
                    }, (err) => {
                        this.retryCount+=1;
                    })
                }else {
                    this.authenticationService.logout();
                }
                    
            }

            const error = (err && err.error.message && err.error) || err.statusText;
            console.error(err);
            return throwError(error);
        }))
    }
}